'use client'

import { useEffect } from 'react'
import { useUser } from '@auth0/nextjs-auth0'

/**
 * Wraps `useUser()` and redirects to /auth/login on the client side
 * when the user is not authenticated. This avoids calling redirect()
 * in server actions which triggers a Next.js bug (vercel/next.js#90591).
 */
export function useRequireAuth() {
  const { user, isLoading, error } = useUser()

  useEffect(() => {
    if (!isLoading && !user) {
      window.location.href = '/auth/login'
    }
  }, [isLoading, user])

  return { user: user ?? null, isLoading }
}
